import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useDevice } from '../../../contexts/DeviceContext.js';
import { cn } from '../../../lib/utils.js';

const ContentInner = forwardRef(
  ({ children, className }, ref) => {
    const { isDesktop, isScroll } = useDevice();
    return /* @__PURE__ */ jsx("div", { ref, className: cn(isDesktop && "w-[600px] mx-auto mt-10", className), children: /* @__PURE__ */ jsx(
      "div",
      {
        className: `transition-all duration-300 ${isScroll ? "overflow-y-auto pb-[36vh]" : ""}`,
        children
      }
    ) });
  }
);
ContentInner.displayName = "ContentInner";

export { ContentInner };
